import { ConfirmationDialogData } from './confirmation-dialog-data.model';

export const CONFIRMATION_DEFAULT_DIALOG_CONFIG: ConfirmationDialogData = {
  title: 'Please Confirm',
  confirmMessage: 'Do you want to proceed',
  okButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
};

export const CONFIRM_DELETE_DIALOG_DEFAULT_CONFIG: ConfirmationDialogData = {
  title: 'Are you sure?',
  confirmMessage: 'This action can NOT be undone. Proceed with caution!',
  okButtonText: 'Delete',
  cancelButtonText: 'Cancel',
};
